<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-header-actions">

                          <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                            <div class="row align-items-end">
                              <div class="col-12 col-sm-8 card-header-search-box">
                                <div class="input-group">
                                  <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search" @keypress.enter="initList">
                                  <div class="input-group-append">
                                      <button class="all-btn search-btn" @click="initList">
                                          <i class="fa fa-search"></i>
                                      </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                            <button class="all-btn add-btn m-0" @click="showProductCategoryModal(null)">{{$t("action.add")}}</button>
                          </div>

                        </div>

                    </div>
                    <div class="card-body table-responsive">
                        <div class="table-wrapper">
                          <table class="table table-hover">
                              <thead>
                              <tr>
                                  <th>#</th>
                                  <th>Коди</th>
                                  <th>Номи</th>
                                  <th>Категорияси</th>
                                  <th>Киритилган сана</th>
                                  <th>Яратган фойдаланувчи</th>
                                  <th>Ўзгартирилган сана</th>
                                  <th>Ўзгартирган фойдаланувчи</th>
                                  <th class="text-center">{{$t("realEstate.field.action")}}</th>
                              </tr>
                              </thead>
                              <tbody v-if="!loading && results && results.data">
                              <tr v-for="result in results.data" :key="result.id">
                                  <td>{{result.id}}</td>
                                  <td>{{result.code}}</td>
                                  <td>{{result.name}}</td>
                                  <td>{{result.parent ? result.parent.name : ''}}</td>
                                  <td>
                                      <template v-if="result.createDate">{{new Date(result.createDate) | dateFormat('DD/MM/YYYY HH:mm')}}</template>
                                  </td>
                                  <td>{{result.createUserName ? result.createUserName : ''}}</td>
                                  <td>
                                      <template v-if="result.updateDate">{{new Date(result.updateDate) | dateFormat('DD/MM/YYYY HH:mm')}}</template>
                                  </td>
                                  <td>
                                      <template v-if="result.updateUserName">{{result.updateUserName}}</template>
                                  </td>
                                  <td class="td-actions text-center">
                                      <button class="all-btn edit-btn table-action" data-original-title="Edit" @click="edit(result)">
                                          <i class="fa fa-edit"></i>
                                      </button>
                                  </td>
                              </tr>
                              </tbody>
                          </table>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <product-category-add-view></product-category-add-view>
    </div>
</template>

<script>
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import ProductCategoryAddView from '@/views/config/product/ProductCategoryAddView';

    export default {
        name: "ProductCategoryList",
        components: {
            'b-pagination': bPagination,
            ProductCategoryAddView
        },
        data() {
            return {
                loading: false,
                results: null,
                filter: initFilterModel()
            }
        },
        methods: {
            initList() {
                this.loading = true;
                const vm = this;
                this.$http.post('product-category/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        vm.loading = false;
                    }, err => {
                        console.log(err);
                        vm.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            showProductCategoryModal(data) {
                this.$eventBus.$emit('showProductCategoryModal', data);
            },
            edit(data) {
                this.$eventBus.$emit("showProductCategoryModal",data)
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('productCategoryChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>

</style>